import {Link, useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {apiClient} from "../api/ApiClient";
import {useEffect, useState} from "react";

export default function Menu() {

    const location = useLocation();
    const { hash, pathname, search } = location;
    const tokenInfo = useSelector(state => state.Token);
    const tokenInfoAdmin = useSelector(state => state.AdminPortal)
    const [token, setToken] = useState("")
    const navigate = useNavigate();

    useEffect( () => {
        setToken(tokenInfo.token)
        if(tokenInfoAdmin.token) {
            setToken(tokenInfoAdmin.token)
        }
    }, [tokenInfo, tokenInfoAdmin])

    const handleExit = () => {
        sessionStorage.clear();
        apiClient.defaults.headers.Authorization = null;
        setToken("");
        if(tokenInfoAdmin.token){
            navigate('/admin/login')
        }else{
            navigate('/')
        }
    }

    return(
        <>
            <div className="menu">
                <nav>
                    <div className={`nav ${tokenInfo.token ? 'nav-exit' : ""}`} id="nav-tab" role="tablist">
                        <Link to="/" className={"nav-link " + ( (pathname != "/learning" && pathname != "/about-us") ? "active" : "")} >دریافت کلید گواهی</Link>
                        <Link to="/learning" className={"nav-link " + (pathname == "/learning" ? "active" : "")}>آموزش</Link>
                        <Link to="/about-us" className={"nav-link " + (pathname == "/about-us" ? "active" : "")}>درباره ما</Link>
                        {token && <p onClick={handleExit} to="/" className={"nav-link m-0 pointer"} style={{color: "red"}}>خروج</p>}
                    </div>
                </nav>

            </div>

            {/*<div className={`img_in_menu`} >*/}
            {/*    <img src={require('../image/logo_header1.png')} />*/}
            {/*    <img src={require('../image/logo_header2.png')} />*/}
            {/*</div>*/}
        </>
)
}